<template>
	<v-scrollable>
		<div class="flex snap-x snap-proximity flex-nowrap space-x-4 md:space-x-8">
			<v-scrollable-item
				v-for="(story, index) in articleLanders"
				:key="index"
				class="shrink-0 snap-start"
			>
				<nuxt-link
					:to="'/' + story.full_slug"
					:class="{
						'font-bold text-black': isActive(story.full_slug),
						'font-normal text-gray-500': !isActive(story.full_slug),
					}"
				>
					{{ story.content.title }}
				</nuxt-link>
			</v-scrollable-item>
		</div>
	</v-scrollable>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

defineProps<{
	articleLanders: ISbStoryData[];
}>();

const route = useRoute();

const trailingSlashRegex = /\/$/;
const trimTrailing = (x: string) => x.replace(trailingSlashRegex, "");

function isActive(slug: string): boolean {
	const isTagSelected = !!route.query?.category;
	return (
		!isTagSelected && trimTrailing(`/${slug}`) === trimTrailing(route.path)
	);
}
</script>

<i18n lang="json">
{
	"et": {
		"recommended-articles": "Soovitatud artiklid"
	},
	"fi": {
		"recommended-articles": "Suositellut artikkelit"
	}
}
</i18n>
